module.exports = __webpack_public_path__ + "img/article-header-preview-5.ca315db3.jpg";